import React from 'react';

interface ConfigurationErrorProps {
  errors: string[];
}

/**
 * Configuration Error Screen
 * Displayed when environment validation fails at startup
 */
export const ConfigurationError: React.FC<ConfigurationErrorProps> = ({ errors }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#1a1a1a',
        color: '#ffffff',
        padding: '2rem',
        fontFamily: 'monospace',
      }}
    >
      <div
        style={{
          maxWidth: '800px',
          width: '100%',
          backgroundColor: '#2d2d2d',
          border: '2px solid #ff4444',
          borderRadius: '8px',
          padding: '2rem',
        }}
      >
        <h1
          style={{
            color: '#ff4444',
            fontSize: '2rem',
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <span>❌</span>
          Configuration Error
        </h1>
        
        <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#cccccc' }}>
          The application cannot start due to missing or invalid environment configuration.
        </p>
        
        <div
          style={{
            backgroundColor: '#1a1a1a',
            border: '1px solid #444444',
            borderRadius: '4px',
            padding: '1rem',
            marginBottom: '1.5rem',
          }}
        >
          <h2 style={{ fontSize: '1.2rem', marginBottom: '1rem', color: '#ff8888' }}>
            Missing or Invalid Variables:
          </h2>
          <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
            {errors.map((error, index) => (
              <li
                key={index}
                style={{
                  marginBottom: '0.5rem',
                  color: '#ffcccc',
                  fontSize: '0.95rem',
                }}
              >
                {error}
              </li>
            ))}
          </ul>
        </div>
        
        <div
          style={{
            backgroundColor: '#1a3a1a',
            border: '1px solid #44aa44',
            borderRadius: '4px',
            padding: '1rem',
          }}
        >
          <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem', color: '#88ff88' }}>
            How to Fix:
          </h3>
          <ol style={{ margin: 0, paddingLeft: '1.5rem', color: '#ccffcc' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              Check your <code style={{ backgroundColor: '#2d2d2d', padding: '0.2rem 0.4rem', borderRadius: '3px' }}>.env.local</code> file
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Ensure all required variables are set with valid values
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Restart the development server after making changes
            </li>
            <li>
              See <code style={{ backgroundColor: '#2d2d2d', padding: '0.2rem 0.4rem', borderRadius: '3px' }}>.env.example</code> for reference
            </li>
          </ol>
        </div>
        
        <div style={{ marginTop: '1.5rem', fontSize: '0.9rem', color: '#888888' }}>
          <p>
            For more information, check the browser console or contact your system administrator.
          </p>
        </div>
      </div>
    </div>
  );
};
